import { useEffect } from 'react';
import { useApiDelete, useApiGet, useApiPatch, useApiPost } from '@sierralabs/core-ui';
export function useCreateFormTemplate() {
    const { data, isLoading, error, post } = useApiPost('form-templates');
    return {
        createdFormTemplate: data,
        isCreating: isLoading,
        createError: error,
        createFormTemplate: post
    };
}
export function useUpdateFormTemplate(id) {
    const { data, isLoading, error, patch } = useApiPatch(`form-templates/${id}`);
    return {
        updatedFormTemplate: data,
        isUpdating: isLoading,
        updateError: error,
        updateFormTemplate: patch
    };
}
export function useUpdateFormTemplateConfig(id) {
    const { data, isLoading, error, patch } = useApiPatch(`form-templates/${id}/delta`);
    return {
        updatedResult: data,
        isUpdating: isLoading,
        updateError: error,
        updateFormTemplateConfig: patch
    };
}
export function usePublishFormTemplate(id) {
    const { data, isLoading, error, post } = useApiPost(`form-templates/${id}/publish`);
    return {
        publishedFormTemplate: data,
        isPublishing: isLoading,
        publishError: error,
        publishFormTemplate: post
    };
}
export function useFindFormTemplates() {
    const { data, isLoading, error, get } = useApiGet('form-templates');
    return {
        formTemplateList: data,
        loadingFormTemplates: isLoading,
        loadingFormTemplatesError: error,
        findFormTemplates: get
    };
}
export function useFindFormTemplate(id, shouldFetchOnMount = false) {
    const { data, isLoading, error, get } = useApiGet(`form-templates/${id}`);
    useEffect(() => {
        if (shouldFetchOnMount) {
            get();
        }
    }, [get, shouldFetchOnMount]);
    return {
        formTemplate: data,
        isLoading,
        loadingError: error,
        findFormTemplate: get
    };
}
export function useFindLatestFormTemplateVersion(id, shouldFetchOnMount = false) {
    const { data, isLoading, error, get } = useApiGet(`form-templates/${id}/versions/latest`);
    useEffect(() => {
        if (shouldFetchOnMount) {
            get();
        }
    }, [get, shouldFetchOnMount]);
    return {
        formTemplateVersion: data,
        isLoading,
        loadingError: error,
        findFormTemplateVersion: get
    };
}
export function useGetFormTemplateVersions(id, shouldFetchOnMount = false) {
    const { data, isLoading, error, get } = useApiGet(`form-templates/${id}/versions`);
    useEffect(() => {
        if (shouldFetchOnMount) {
            get();
        }
    }, [get, shouldFetchOnMount]);
    return {
        formTemplateVersions: data,
        isLoading,
        loadingError: error,
        getFormTemplateVersions: get
    };
}
export function useDeleteFormTemplate(id) {
    const { data, isLoading, error, del } = useApiDelete(`form-templates/${id}`);
    return {
        deletedFormTemplate: data,
        deletingFormTemplate: isLoading,
        deleteError: error,
        deleteFormTemplate: del
    };
}
//# sourceMappingURL=FormTemplate.hooks.js.map